import React from "react";
import Expander from "../../Expander";
import { getVarsoUrl } from "../../../common/helpers/helpers";
import helpers from "../../../common/utils/utils";
import PublicationLinks from "../../Publications/components/PublicationLinks";

const chemicalUrl = "https://www.pharmgkb.org/chemical/";

const getEvidenceTable = (items) => {
  const result = (
    <div>
      <Expander showMore="5">
        {items.map((item, key) => {
          const z = `${key}_dl`;
          let id = item.evidence_id;
          if (item.evidence_id && item.evidence_url) {
            id = (
              <a href={getVarsoUrl(item.evidence_url)} target="_blank">
                {item.evidence_id}
              </a>
            );
          }
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={z}>
              {id && (
                <span>
                  <dt className="col-12 col-xs-12">ID</dt>
                  <dd className="col-12 col-xs-12">
                    <a href={getVarsoUrl(item.evidence_url)} target="_blank">
                      {id}
                    </a>
                  </dd>
                </span>
              )}
              {item.evidence_type && (
                <span>
                  <dt className="col-12 col-xs-12">Type</dt>
                  <dd className="col-12 col-xs-12">
                    {helpers.capitalizeFirstLetter(
                      item.evidence_type.toLowerCase()
                    )}
                  </dd>
                </span>
              )}
              {item.score !== null && (
                <span>
                  <dt className="col-12 col-xs-12">Score</dt>
                  <dd className="col-12 col-xs-12">{item.score}</dd>
                </span>
              )}
              {item.summary && (
                <span>
                  <dt className="col-12 col-xs-12">Summary</dt>
                  <dd className="col-12 col-xs-12">{item.summary}</dd>
                </span>
              )}
            </dl>
          );
        })}
      </Expander>
    </div>
  );
  return result;
};

export const getClinicalAnnotationsTableMobile = (items) => {
  const result = (
    <div>
      <Expander showMore="5">
        {items.map((item, key) => {
          const z = `${key}_dl`;
          return (
            <dl className="dl-horizontal varsome-dl-horizontal" key={z}>
              {item.chemical_relations &&
                item.chemical_relations.length > 0 && (
                  <span>
                    <dt className="col-12 col-xs-12">Drugs</dt>
                    {item.chemical_relations.map((obj, i) => {
                      const v = `${key}_${i}`;
                      return (
                        <dd key={v} className="col-12 col-xs-12">
                          <a
                            href={getVarsoUrl(chemicalUrl + obj.id)}
                            target="_blank"
                          >
                            {helpers.capitalizeFirstLetter(
                              obj.name.toLowerCase()
                            )}
                          </a>
                        </dd>
                      );
                    })}
                  </span>
                )}
              {item.id && (
                <span>
                  <dt className="col-12 col-xs-12">Clinical Annotation ID</dt>
                  <dd className="col-12 col-xs-12">
                    <a href={getVarsoUrl(item.url)} target="_blank">
                      {item.id}
                    </a>
                  </dd>
                </span>
              )}
              {item.annotation_type && (
                <span>
                  <dt className="col-12 col-xs-12">Annotation Type</dt>
                  <dd className="col-12 col-xs-12">
                    {helpers.capitalizeFirstLetter(
                      item.annotation_type.toLowerCase()
                    )}
                  </dd>
                </span>
              )}
              {item.ethnicity && (
                <span>
                  <dt className="col-12 col-xs-12">Ethnicity</dt>
                  <dd className="col-12 col-xs-12">
                    {helpers.capitalizeFirstLetter(
                      item.ethnicity.toLowerCase()
                    )}
                  </dd>
                </span>
              )}
              {item.level_of_evidence && (
                <span>
                  <dt className="col-12 col-xs-12">
                    <a
                      href={getVarsoUrl(
                        "https://www.pharmgkb.org/page/clinAnnLevels"
                      )}
                      target="_blank"
                    >
                      Level Of Evidence
                    </a>
                  </dt>
                  <dd className="col-12 col-xs-12">{item.level_of_evidence}</dd>
                </span>
              )}
              {item.score && (
                <span>
                  <dt className="col-12 col-xs-12">Score</dt>
                  <dd className="col-12 col-xs-12">{item.score}</dd>
                </span>
              )}
              {item.pub_med_references && (
                <span>
                  <dt className="col-12 col-xs-12">Publications</dt>
                  <dd className="col-12 col-xs-12">
                    <PublicationLinks ids={item.pub_med_references} />
                  </dd>
                </span>
              )}
              {item.annotation_text && item.annotation_text.length > 0 && (
                <span>
                  <dt className="col-12 col-xs-12">Annotation</dt>
                  {item.annotation_text.map((obj, i) => {
                    const m = `${key}_${i}`;
                    return (
                      <dd key={m} className="col-12 col-xs-12">
                        {obj}
                      </dd>
                    );
                  })}
                </span>
              )}
              {item.evidence && (
                <span>
                  <dt className="col-12 col-xs-12">Evidence</dt>
                  <dd className="col-12 col-xs-12">
                    {getEvidenceTable(item.evidence)}
                  </dd>
                </span>
              )}
            </dl>
          );
        })}
      </Expander>
    </div>
  );
  return result;
};
